export const READER_SIDE_PANEL_WIDTH_PX = 448;
export const TEXT_CHAT_2XL_MIN_WIDTH_PX = 1536;

export const READER_SIDE_PANEL_SPRING_TRANSITION = {
  type: 'spring' as const,
  stiffness: 380,
  damping: 38,
};
